"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_use_1 = require("react-use");
const strings_1 = require("../../../../constants/strings");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../zustandStore");
const teamSwitcherMenu_1 = __importDefault(require("./teamSwitcherMenu"));
require("./index.less");
const logger = (0, pino_1.default)();
const SideMenuTeamSwitcher = () => {
    const { data: teams = [] } = (0, react_query_1.useQuery)((0, teamQuery_1.teamsQuery)({ state: 'active' }));
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: currentTeam } = (0, teamQuery_1.useGetCurrentTeamQuery)(teams, teamId);
    const saveUserSetting = (0, userQuery_1.useSaveUserSettingQuery)();
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const isTeamSwitcherAsideOpen = (0, zustandStore_1.useZustand)(state => state.sideMenu.isTeamSwitcherAsideOpen);
    const { openSideMenuOnDesktopView, setIsOpenTeamSwitcherAside, setPageLoading, setPreventShowErrorPage } = (0, zustandStore_1.useZustand)();
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const selectedTeam = Array.isArray(teams) && teams.length > 0 && teams.find(team => team.id === teamId?.[0] || '');
    const closeAside = (0, react_1.useCallback)(() => {
        setIsOpenTeamSwitcherAside(false);
        if (!isMobileWidth) {
            openSideMenuOnDesktopView(false);
        }
    }, [isMobileWidth, openSideMenuOnDesktopView, setIsOpenTeamSwitcherAside]);
    (0, react_1.useEffect)(() => {
        if (!currentTeam) {
            return;
        }
        if (Array.isArray(teamId) && teamId.length === 0 && currentTeam?.id) {
            saveUserSetting.mutate({ selectedTeamID: currentTeam.id });
        }
    }, [currentTeam, teamId]);
    (0, react_1.useEffect)(() => {
        if (isTeamSwitcherAsideOpen && !isMobileWidth) {
            openSideMenuOnDesktopView(false);
        }
    }, [isMobileWidth, isTeamSwitcherAsideOpen, openSideMenuOnDesktopView]);
    const selectTeam = (teamData) => {
        closeAside();
        setPreventShowErrorPage(true);
        setPageLoading(true);
        saveUserSetting.mutate({ selectedTeamID: teamData.id }, {
            onError: error => {
                logger.error({ message: 'Error while saving user setting', error });
            },
            onSettled: () => {
                // we need full page refresh here to get new values from the server
                // eslint-disable-next-line react-compiler/react-compiler
                globalThis.location.href = (0, userSelectors_1.isCompanyOrSupportAdmin)(userData?.roles || []) ? '/wallet' : '/wallet/my-cards';
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { "data-testid": "sideMenu-drawer", "ts-variant": "sideMenuTeamSwitcher", className: isTeamSwitcherAsideOpen ? 'open' : 'closed', children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "header", "ts-variant": "teamSwitcherHeaderTitle", children: strings_1.sideMenuStrings.SIDE_MENU_TEAM_SWITCHER_OPTION }), (0, jsx_runtime_1.jsx)(Close_1.default, { "ts-variant": "teamSwitcherCloseIcon", onClick: () => closeAside() }), (0, jsx_runtime_1.jsx)(material_1.MenuList, { className: "side-menu-team-switcher__menu", children: selectedTeam && teams && teams.length > 0
                    ? teams.map(team => ((0, jsx_runtime_1.jsx)(teamSwitcherMenu_1.default, { onClick: () => selectTeam(team), team: { ...team, selected: team.id === selectedTeam.id } }, team.id)))
                    : null })] }));
};
exports.default = (0, react_1.memo)(SideMenuTeamSwitcher);
